<template>
  <div>
    <header-slot></header-slot>
    <b-card
      no-body
      class="border-top-primary border-3 border-table-radius px-0"
    >
      <GridTable />
    </b-card>
  </div>
</template>

<script>
/* Components */
import GridTable from "@/views/monitoring/views/attendance/components/GirdTable.vue";

export default {
  components: {
    GridTable,
  },
};
</script>

<style>
</style>